import { components, OptionProps, OptionTypeBase } from 'react-select';
import cn from 'classnames';
// Types
import { SearchResultType } from 'api/graphql-analytics-global-types';
import { SearchBarOptionProps } from 'components/HomePage/components/V3/SearchBar/SearchBar';
// Helpers
import { formatCurrencyString } from 'helpers/formatCurrencyString';
// Ui3
import Image from 'ui3/Image/Image';
import MillionsIcon from 'ui3/MillionsIcon/MillionsIcon';
// Styles
import styles from './SearchOption.module.scss';

const SearchOption = (props: OptionProps<OptionTypeBase, boolean>) => {
  const data = props.data as SearchBarOptionProps;

  const isAthleteOrCreator =
    data.type === SearchResultType.Athlete ||
    data.type === SearchResultType.ContentCreator ||
    data.type === SearchResultType.Organization;

  const isStream = data.type === SearchResultType.Stream;

  const isMediaPost = data.type === SearchResultType.MediaPost;

  const isProduct =
    data.type === SearchResultType.Merch ||
    data.type === SearchResultType.Memorabilia ||
    data.type === SearchResultType.Product ||
    data.type === SearchResultType.Experience;

  const formattedPrice =
    data.price !== null && data.price !== undefined
      ? data.isFree
        ? 'FREE'
        : formatCurrencyString(data.price)
      : null;

  return (
    <components.Option {...props}>
      <div className={styles.option}>
        {data.imageUrl && (
          <div
            className={cn(styles.imageWrapper, {
              [styles.avatar]: isAthleteOrCreator,
              [styles.thumbnail]: isStream || isMediaPost,
              [styles.product]: isProduct,
            })}
          >
            <Image src={data.imageUrl} alt={data.name} />
            {formattedPrice && (isStream || isProduct) && (
              <span className={styles.priceBadge}>{formattedPrice}</span>
            )}
            {isMediaPost && data.isVideo && (
              <span className={styles.playButton}>
                <MillionsIcon name="play" size={20} />
              </span>
            )}
          </div>
        )}

        <div className={styles.content}>
          <div className={styles.titleRow}>
            <span className={styles.title}>{data.name}</span>

            {isAthleteOrCreator && data.sports && data.sports.length > 0 && (
              <div className={styles.sportTags}>
                {data.sports.slice(0, 1).map((sport) => (
                  <span key={sport} className={styles.sportTag}>
                    {sport.toUpperCase()}
                  </span>
                ))}
              </div>
            )}
          </div>

          {isAthleteOrCreator && data.username && (
            <span className={styles.username}>{data.username}</span>
          )}

          {(isStream || isProduct || isMediaPost) && data.storeName && (
            <span className={styles.storeName}>{data.storeName}</span>
          )}

          {isStream && data.scheduleDate && (
            <span className={styles.scheduleDate}>
              {new Date(data.scheduleDate).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
              })}
            </span>
          )}
        </div>
      </div>
    </components.Option>
  );
};

export default SearchOption;
